import { useAuthStore } from "@/stores/auth";
import isMiddleware from "@/router/middleware/isMiddleware";
import { SetRedirectPath } from "@/utils/redirectPath";

const needle = "auth";

export default function (to, from, next) {
  const rule = to.meta["middleware"];

  if (!rule || !isMiddleware(needle, rule)) return false;

  const authStore = useAuthStore();

  const hasUser = !!authStore.userData;

  return hasUser ? false : toLogin(to, from, next);
}

const toLogin = (to, from, next) => {
  SetRedirectPath(to.fullPath);

  return next({ name: "login" });
};
